import * as React from 'react';
import * as PropTypes from 'prop-types';
import { classNames } from '@progress/kendo-react-common';
/**
 * Returns the action bar of the Dialog.
 *
 * @returns React.ReactElement
 */
export var DialogActionsBar = function (props) {
    var _a = props.layout, layout = _a === void 0 ? defaultProps.layout : _a, children = props.children;
    var wrapperClasses = classNames('k-dialog-buttongroup', 'k-actions', {
        'k-actions-start': layout === 'start',
        'k-actions-center': layout === 'center',
        'k-actions-end': layout === 'end',
        'k-actions-stretched': layout === 'stretched'
    });
    return (React.createElement("div", { className: wrapperClasses }, children));
};
DialogActionsBar.propTypes = {
    children: PropTypes.any,
    layout: PropTypes.oneOf(['start', 'center', 'end', 'stretched'])
};
var defaultProps = {
    layout: 'stretched'
};
//# sourceMappingURL=DialogActionsBar.js.map